/* This file was generated automatically. Do not edit manually. */

export enum LedgerActivityReportLedgerType {
    Revenue = 'Revenue',
    NonRevenue = 'NonRevenue',
    Payments = 'Payments',
    Deposit = 'Deposit',
    Guest = 'Guest',
    City = 'City',
    Outlets = 'Outlets',
}
